export default "__VITE_ASSET__ee1e8362__"